import { put, takeLatest } from "redux-saga/effects";

import { EToastType } from "@/components/common/AlertToast/AlertToast.types";
import apiErrorHandler from "@/utils/apiErrorHandler";
import {
  GET_PROBLEMS_FROM_LIBRARY_API_HTTP_STATUS_CODES,
  GET_PROBLEMS_FROM_LIBRARY_ERROR_MESSAGE,
} from "@/constants/ProblemTypeConstants";
import { showToast } from "../actions/appStatus.action";
import { updateLibraryProgress } from "../actions/progress.action";
import { getProblemsFromLibraryAPI } from "../api/problems.api";
import { GET_LIBRARY_PROBLEMS } from "../constants/ActionTypes";
import {
  IGetLibraryProblemsArgs,
  TGetLibraryProblemsParams,
} from "../types/problems.types";
import { call } from "./utils.saga";

function* getLibraryProblems({ payload }: IGetLibraryProblemsArgs) {
  try {
    yield put(updateLibraryProgress(true));
    const {
      level,
      limit,
      offset,
      category,
      problemType,
      slug,
      problemName,
      tags,
      technologies,
    } = payload;
    let params: TGetLibraryProblemsParams = {
      limit,
      offset,
      problem_type: problemType,
      query: problemName,
      tags,
      level,
      technologies,
    };

    if (category === "interview") {
      params = { ...params, interview_slug: slug };
    } else {
      params = { ...params, category };
    }

    const resp = yield* call(getProblemsFromLibraryAPI, params);

    yield put({
      type: `${GET_LIBRARY_PROBLEMS}_SUCCESS`,
      payload: {
        results: resp.data.results,
        meta: {
          previous: resp.data.previous,
          next: resp.data.next,
          count: resp.data.count,
          totalPages: Math.ceil(resp.data.count / +limit),
        },
      },
    });
  } catch (error: unknown) {
    const message = yield* call(
      apiErrorHandler,
      error,
      GET_PROBLEMS_FROM_LIBRARY_API_HTTP_STATUS_CODES,
      GET_PROBLEMS_FROM_LIBRARY_ERROR_MESSAGE,
    );
    if (message)
      yield put(
        showToast({
          message,
          type: EToastType.ERROR,
        }),
      );
  } finally {
    yield put(updateLibraryProgress(false));
  }
}

export default function* loadLibrarySaga() {
  yield takeLatest(GET_LIBRARY_PROBLEMS, getLibraryProblems);
}
